
  import { defineComponent } from 'vue';
  import './link.scss';

  /**
   * Link component.
   * 
   * Can be used to wrap around a component or more, for example: <code>&lt;Link href="..."&gt;...&lt;/Link&gt;</code>
   * 
   * Or as a basic text only link as follows: <code>&lt;Link content="..." href="..." /&gt;</code>
   * 
   * @example
   * <code>import TpxLink from '@manifesto-tech/tpximpact-design-system/components/atoms/link/link.vue'</code>
   */
  export default defineComponent({
    name: 'TpxLink',
    
    props: {
      /**
       * The text content of the link
       */
      content: {
        type: String,
      },

      /**
       * The destination of the link
       */
      href: {
        type: String,
        required: true,
      },

      /**
       * Is the link active/selected?
       */
      isSelected: {
        type: Boolean,
      },

      /**
       * Title: descriptive text about the link
       */
      title: {
        type: String,
      },

      /**
       * Opt if the underline should be added to the container or a child span
       */
      underlineSpan: {
        type: Boolean,
      },
    },
  });
